export default "__VITE_ASSET__Dws9aCUA__"